'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import DateInput from './DateInput.jsx';
import DateOfBirthVerifier from 'ck-core/source/verifiers/user/DateOfBirthVerifier';

export default class DateOfBirthInput extends React.Component {
	render() {
		return (
			<DateInput
				{...this.props}
				label={this.props.label}
				name={this.props.name}
				validate={new DateOfBirthVerifier()}
			/>
		);
	}
}

DateOfBirthInput.propTypes = {
	label: PropTypes.string,
	name: PropTypes.string
};

DateOfBirthInput.defaultProps = {
	label: 'Date of Birth',
	name: 'dateOfBirth',
	emptyValue: DateInput.defaultProps.emptyValue
};
